// @flow
import { createAction } from 'redux-actions';

export const setFlags = createAction('FF_SET_FLAGS');
export const setFlagsMeta = createAction('FF_SET_FLAGS_META');
export const setFlag = createAction('FF_SET_FLAG');
export const getFlags = createAction('GET_FF');
export const getFlagsSuccess = createAction('GET_FF_SUCCESS');
export const getFlagsFailure = createAction('GET_FF_FAILURE');
